import * as yup from 'yup';

function brandCode(formatMessage, isEdit) {
  if (isEdit) {
    return yup.string();
  }
  return yup.string().required(
    formatMessage({
      id: 'BRAND_CODE_IS_REQUIRED',
      defaultMessage: 'Brand Code is required',
    }),
  );
}

function brandName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'BRAND_NAME_IS_REQUIRED',
      defaultMessage: 'Brand Name is required',
    }),
  );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = (formatMessage, isEdit) =>
  yup
    .object({
      brandCode: brandCode(formatMessage, isEdit),
      brandName: brandName(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
